export type CampaignSponsorType = 'WOLT' | 'MERCHANT' | 'THIRD_PARTY' | 'WOLT_AND_MERCHANT' | 'WOLT_AND_THIRD_PARTY';
export type CampaignBudgetType = 'WOLT' | 'MERCHANT' | 'SHARED';

export type DiscountValue = {
  amount?: number | null;
  percentage?: number | null;
  upper_limit?: number | null;
};

export type DiscountConfig = {
  amounts: number[];
  percentages: number[];
  recommended_percentage: number;
  recommended_amount: number;
  upper_limits: number[];
};

export type OpeningTimeType = 'open' | 'close';

export type OpeningTime = {
  type: OpeningTimeType;
  value: string;
};

export type WeeklySchedule = {
  monday: OpeningTime[];
  tuesday: OpeningTime[];
  wednesday: OpeningTime[];
  thursday: OpeningTime[];
  friday: OpeningTime[];
  saturday: OpeningTime[];
  sunday: OpeningTime[];
};

export enum CampaignType {
  DELIVERY_DISCOUNT = 'DeliveryDiscount',
  BASKET_DISCOUNT = 'BasketDiscount',
  ADS = 'Ads',
  ITEM_DISCOUNT = 'ItemDiscount',
  END_OF_DAY = 'EndOfDay',
}

export enum BasketDiscountType {
  PERCENTAGE = 'percentage',
  AMOUNT = 'amount',
}

export type ItemDiscountOptions = {
  percentage: {
    min_percentage: number;
    max_percentage: number;
  };
};

export type Campaign = {
  id: string;
  campaign_type: CampaignType;
  name: string;
  description: string;
  start_date: string;
  end_date: string;
  terminated: boolean;
  total_budget_sum: number | null;
  per_user_usage_limit: number | null;
  first_purchase_only: boolean;
  total_spent_budget?: number;
  created_by: string;
  venue_ids: string[];
  min_basket_size?: number;
  max_delivery_distance: number;
  basket_discount: DiscountValue;
  delivery_discount: DiscountValue;
  item_discount: ItemDiscountConfig;
  weekly_schedule: WeeklySchedule | null;
  sponsor_type: CampaignSponsorType;
  budget_type: CampaignBudgetType;
  created_at: string;
  created_by_wolt: boolean;
  currency: Currency;
  is_end_of_day_campaign?: boolean;
};

export type AmountOffDiscount = {
  amount: number;
  percentage: null;
  free_items_count: null;
};

export type PercentageOffDiscount = {
  amount: null;
  percentage: number;
  free_items_count: null;
};

export type XForFreeDiscount = {
  amount: null;
  percentage: null;
  free_items_count: number;
};

export type ItemDiscountConfigVariants = AmountOffDiscount | PercentageOffDiscount | XForFreeDiscount;

export type ItemDiscountConfig = {
  item_trigger_count: number;
  target_item: {
    item_id: string;
    venue_id: string;
  };
} & ItemDiscountConfigVariants;

export type PaginatedResponse<T> = {
  results: T[];
  page: number;
  page_size: number;
  total_pages: number;
  document_count: number;
};

export type CampaignConfiguration = {
  campaign_types: CampaignType[];
  max_delivery_distances: number[];
  basket_discounts: Record<number, DiscountConfig>;
  delivery_discounts: Record<number, DiscountConfig>;
  item_discount: ItemDiscountOptions;
  default_total_budget_sum: number;
  promotion_per_venue_limit: number;
};
